module.exports = __webpack_public_path__ + "static/img/pic3.8ead0b0.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/video/pic3.png
// module id = 1717
// module chunks = 2